import React from "react"
import "../../section.css"
// import { Link } from "react-router-dom"

const Section = () => {
    const gotoHome = () => {
        window.location.href = '/home';
        localStorage.setItem('startexperience', '1');
    }
    return (
        <div className="section_main">
            <section class="showcase">
                <div class="container-fluid p-0">
                    <div class="row no-gutters">
                        <div class="col-6 order-1 text-white showcase-img img-2"></div>
                        <div class="col-6 order-2 my-auto showcase-text">
                            <div className="head sp-r">
                                <p>Read Amazing<br />Folios And Learn<br />New Things</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="showcase">
                <div class="container-fluid p-0">
                    <div class="row no-gutters">
                        <div class="col-6 order-2 text-white showcase-img img-3">
                        </div>
                        <div class="col-6 order-1 my-auto showcase-text">
                            <div className="head sp-l">
                                {/* <p>Spread Your Reach By<br />Uploading Interesting <br />Folios And Connect To<br />Millions Of Readers Directly</p> */}
                                <p>Spread Your Reach By Uploading Interesting Folios And Connect To Millions Of Readers Directly</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="showcase">
                <div class="container-fluid p-0">
                    <div class="row no-gutters">
                        <div class="col-6 order-1 text-white showcase-img img-4">
                        </div>
                        <div class="col-6 order-2 my-auto showcase-text">
                            <div className="head sp-r">
                                <p>Easily Share And<br />Discuss Folios With<br />Your Friends</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <button onClick={gotoHome} className="exp" >Start Experiencing</button>
        </div>
    )
}
export default Section;